import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import LieDetector from "../pages/lie-detector/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import TermsAndConditions from "../pages/terms-and-conditions/page";
import Admin from "../pages/admin/page";
import ThankYou from "../pages/thank-you/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/lie-detector",
    element: <LieDetector />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms-and-conditions",
    element: <TermsAndConditions />,
  },
  {
    path: "/admin",
    element: <Admin />,
  },
  {
    path: "/thank-you",
    element: <ThankYou />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;